import { lzFPascalToWordCase } from '@lz-services/String';

type LzTAppBasics = {
    app_code: string;
    app_name?: string;
    app_base_url?: string;
    api_base_url?: string;
    debug_mode_enabled?: boolean;
};

export default class LzSAppBasics {
    private static _app_code: string;
    private static _app_name: string;
    private static _app_base_url: string;
    private static _api_base_url: string;
    private static _debug_mode_enabled: boolean;

    /**
     * Call this method in a file `AppBasicsInit.ts` and use the returned value in your `App.tsx` 
     * in a temp variable so that this function is called at all costs. Also make sure that the
     * file `AppBasicsInit.ts` is the top most import in the `App.tsx` file of your project.
     * 
     * @param params LzTAppBasics App basics parameters.
     * 
     * @returns string
     */
    public static init(params: LzTAppBasics): string {
        LzSAppBasics._app_code = params.app_code;
        LzSAppBasics._app_name = params.app_name || lzFPascalToWordCase(LzSAppBasics._app_code);
        LzSAppBasics._app_base_url = params.app_base_url || '';
        LzSAppBasics._api_base_url = params.api_base_url || '';
        LzSAppBasics._debug_mode_enabled = !!params.debug_mode_enabled;

        return 'ok'; // just return anything
    }

    public static get app_code(): string {
        return LzSAppBasics._app_code;
    }
    public static get app_name(): string {
        return LzSAppBasics._app_name;
    }
    public static get app_base_url(): string {
        return LzSAppBasics._app_base_url;
    }
    public static get api_base_url(): string {
        return LzSAppBasics._api_base_url;
    }

    public static get debug_mode_enabled(): boolean {
        return LzSAppBasics._debug_mode_enabled;
    }
}
